/*
 * ===============================================================================================================
 *                                Copyright 2023, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { FETCH_LOCATIONS_TO_ROLE_SUCCESS, FETCH_LOCATIONS_TO_ROLE_REQUEST, FETCH_LOCATIONS_TO_ROLE_FAILURE } from './types';
import { IPage } from '../../../models/Roles/Locations';

export const fetchLocationsToRoleRequest = () => ({
  type: FETCH_LOCATIONS_TO_ROLE_REQUEST
});

export const fetchLocationsToRoleSuccess = (locations: string[], page: IPage) => ({
  type: FETCH_LOCATIONS_TO_ROLE_SUCCESS,
  locations,
  page
});

export const fetchLocationsToRoleFailure = (error: any) => ({
  type: FETCH_LOCATIONS_TO_ROLE_FAILURE,
  error
});
